import { leadGeneratorThreadPrefetchService } from "../services/thread";

import { createLeadGeneratorRoutingHooks } from "./leadGeneratorRoutingHooks";
import { createRoutingHooksProxy } from "./routingHooksProxy";

const leadGeneratorRoutingHooks = createRoutingHooksProxy(
    createLeadGeneratorRoutingHooks(leadGeneratorThreadPrefetchService),
);

export default leadGeneratorRoutingHooks;
